<button
    type="button" 
    class="btn btn-primary"
    [disabled]="disabled || isProcessing"
    (click)="onButtonClick()" 
>
<i 
class="fas  pr-3" 
[class.fa-spin]="isProcessing"
[class.fa-spinner]="isProcessing"
></i> &nbsp;
<ng-content></ng-content> 
</button>